export const smartTrim = (text: string | any, maxLength = 80) => {
  if (text?.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};
